import { Action } from 'redux';

// State
export interface ActionButtonsState {
	actionButtonsVisible: boolean;
	showMeasurements?: boolean;
	disableShowMeasurements?: boolean;
	showFunctionSleep?: boolean;
	showFunctionStorage?: boolean;
	showFunctions?: boolean;
	disableShowFunctionSleep?: boolean;
	disableShowFunctionStorage?: boolean;
	disableShowFunctions?: boolean;
	showSelectAll?: boolean;
	disableShowSelectAll?: boolean;
}

// Actions
export const SET_ACTION_BUTTONS_VISIBLE = 'SET_ACTION_BUTTONS_VISIBLE';
export const SET_SHOW_FUNCTION_SLEEP = 'SET_SHOW_FUNCTION_SLEEP';
export const SET_SHOW_FUNCTION_STORAGE = 'SET_SHOW_FUNCTION_STORAGE';
export const SET_SHOW_FUNCTIONS = 'SET_SHOW_FUNCTIONS';
export const SET_SHOW_SELECT_ALL = 'SET_SHOW_SELECT_ALL';
export const SET_SHOW_MEASUREMENTS = 'SET_SHOW_MEASUREMENTS';
export const SET_ROTATION_BUTTON_CLICKED = 'SET_ROTATION_BUTTON_CLICKED';

interface SetActionButtonsVisible extends Action {
	type: typeof SET_ACTION_BUTTONS_VISIBLE;
	value: boolean;
}

interface ShowFunctionSleep extends Action {
	type: typeof SET_SHOW_FUNCTION_SLEEP;
	value: boolean;
	track: boolean;
}

interface ShowFunctionStorage extends Action {
	type: typeof SET_SHOW_FUNCTION_STORAGE;
	value: boolean;
	track: boolean;
}

interface ShowFunctions extends Action {
	type: typeof SET_SHOW_FUNCTIONS;
	value: boolean;
}

interface ShowSelectAll extends Action {
	type: typeof SET_SHOW_SELECT_ALL;
	value: boolean;
}

interface ShowMeasurements extends Action {
	type: typeof SET_SHOW_MEASUREMENTS;
	value: boolean;
	track: boolean;
}

interface SetRotationButtonClicked extends Action {
	type: typeof SET_ROTATION_BUTTON_CLICKED;
	value: boolean;
}

export type ActionButtonsStateActions =
	| SetActionButtonsVisible
	| ShowFunctionSleep
	| ShowFunctionStorage
	| ShowFunctions
	| ShowSelectAll
	| ShowMeasurements
	| SetRotationButtonClicked;
